import type { FC } from "react";
import type { UUID } from "../../utils/uuid";
import { useCreateAssetCallback } from "./hooks/use-upsert-asset";
import type { Asset } from "./server/digital-asset-service";
import { UploadFileModal } from "./upload-file-modal";
import type { UiFolderId } from "./utils";

export const UploadNewFileModal: FC<{
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  onCancel: () => void;
  onChange: (folderId: UiFolderId | null) => void;
  onViewFileClick: (asset: Asset) => void;
  folderId: UUID | null;
  folders_feature_flag?: boolean;
}> = ({ ...props }) => {
  const createAsset = useCreateAssetCallback();

  return (
    <UploadFileModal
      heading="Upload file"
      onSave={createAsset}
      allowedFileTypes={["image", "video", "pdf"]}
      {...props}
    />
  );
};
